import { createBrowserRouter } from 'react-router-dom';
// import Home from 'pages/Home';
// import FAQ from 'pages/FAQ';
// import About from 'pages/About';
// import Advantages from 'pages/Advantages';
import Education from 'pages/Education';
import Join from 'pages/Join';
import Personal from 'pages/Personal';
import Login from 'pages/Login/Login';
import BuySubscription from 'pages/BuySubscription/BuySubscription';
import SubscriptionPaid from 'pages/SubscriptionPaid/SubscriptionPaid';
// import Error404 from 'pages/Error404/Error404';
import ProtectedRoutes from 'components/ProtectedRoutes/ProtectedRoutes';
import Booking from 'pages/Booking/Booking';
import MyTimesheet from 'pages/MyTimesheet/MyTimesheet';
import SignUp from 'pages/SignUp/SignUp';
import LanguageWrapper from 'components/LanguageWrapper/LanguageWrapper';
import PasswordReset from 'pages/PasswordReset';
import Account from 'pages/Account/Account';

export const router = createBrowserRouter(
	[
		{
			element: <LanguageWrapper/>,
			children: [
				{
					path: 'א-זה-חינוך',
					element: <Education/>,
				},
				{
					path: 'en/alef-is-education',
					element: <Education/>,
				},
				{
					path: 'כְּנִיסָה-לַמַעֲרֶכֶת',
					element: <Login/>,
				},
				{
					path: 'en/login',
					element: <Login/>,
				},
				{
					path: '/סיסמא-איפוס',
					element: <PasswordReset/>,
				},
				{
					path: 'en/password-reset',
					element: <PasswordReset/>,
				},
				{
					path: 'הרשמה',
					element: <SignUp/>,
				},
				{
					path: 'en/sign-up',
					element: <SignUp/>,
				},
				{
					path: 'הצטרפות',
					element: <Join/>,
				}, {
					path: 'en/join-us',
					element: <Join/>,
				},
				{
					element: <ProtectedRoutes/>,
					children: [
						{
							path: 'email/verify',
							element: <Personal/>
						},
						{
							path: 'en/account',
							element: <Account />
						},
						{
							path: 'התחברות',
							element: <Personal/>,
						},
						{
							path: 'en/personal',
							element: <Personal/>,
						},
						{
							path: 'תיאום',
							element: <Booking/>,
						},
						{
							path: 'en/booking',
							element: <Booking/>,
						},
						{
							path: 'מערכת',
							element: <MyTimesheet/>,
						},
						{
							path: 'en/timesheet',
							element: <MyTimesheet/>,
						},
						{
							path: 'רישום',
							element: <BuySubscription/>,
						},
						{
							path: 'en/subscribe',
							element: <BuySubscription/>,
						},
						{
							path: 'הוזמן',
							element: <SubscriptionPaid/>,
						},
						{
							path: 'en/successful-booking',
							element: <SubscriptionPaid/>,
						},
					],
				},
			]
		},
	]);
